

















































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Mutation, Getter } from 'vuex-class';
import { IUser } from '~/store/profile/types';
import { ICurrentPage, IPreviousPage } from '~/store/types';
import ProfileNavigationDrawer from '~/components/Home/ProfileNavigationDrawer.vue';
import ProfileProgressIcon from '~/components/Home/ProfileProgressIcon.vue';
import WalletConnectionErrorBanner from '~/components/Home/WalletConnectionErrorBanner.vue';
import FullScreenDialog from '~/components/FullScreenDialog.vue';
import LoginAndRegister from '~/components/Authentication/LoginAndRegister.vue';
import DiscordConnect from '~/components/Discord/DiscordConnect.vue';
import NotificationBell from '~/components/SvgIcons/NotificationBell.vue';
import TriggerWalletCreationBtn from '~/components/NewWallet/TriggerWalletCreationBtn.vue';
import ReferAFriend from '~/components/Share/ReferralDialog.vue';
import PromoPackDialog from '~/components/Home/PromoPackDialog.vue';

@Component({
  components: {
    ProfileNavigationDrawer,
    ProfileProgressIcon,
    FullScreenDialog,
    LoginAndRegister,
    NotificationBell,
    DiscordConnect,
    TriggerWalletCreationBtn,
    ReferAFriend,
    PromoPackDialog,
    WalletConnectionErrorBanner,
  },
})
export default class TopToolbar extends Vue {
  @Prop(Array) readonly tabs!: {
    icon: string;
    title: string;
    to: string;
    target: '_blank';
    requirement: boolean;
    mobile: boolean;
  };
  @Prop(Boolean) readonly showWalletPrompt!: boolean;
  @Prop(Boolean) readonly showPromoPackPrompt!: boolean;
  @Prop(Boolean) readonly showTopNavbarLinks!: boolean;
  @Prop(Boolean) readonly showTopToolbarBannerCloseBtn!: boolean;
  @State('currentPage') currentPage!: ICurrentPage;
  @State('previousPage') previousPage!: IPreviousPage;
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @State('discordLink') readonly discordLink!: string;
  @State(profile => profile.user.goldMember, { namespace: 'profile' })
  readonly goldMember!: boolean;
  @State(notifications => notifications.newNotifications.total, {
    namespace: 'notifications',
  })
  readonly newNotificationCount!: number;
  @State(cmsContent => cmsContent.promoPack, {
    namespace: 'cmsContent',
  })
  readonly promoPack!: any;

  @Getter('showWalletConnectionErrorBanner', { namespace: 'web3Wallet' })
  readonly showWalletConnectionErrorBanner!: boolean;

  @Mutation toggleReferralDialog!: (args: any) => void;
  @Mutation togglePromoPackDialog!: (args: any) => void;

  @Action('userLogout', { namespace: 'profile' })
  private userLogout!: () => void;
  @Action('getNewNotifications', { namespace: 'notifications' })
  private getNewNotifications!: () => void;

  drawerControl = false;
  clipped = true;
  showCongratsModal = false;
  nodeLink = process.env.nodeDashboardUrl;

  get logo() {
    return require(`@/assets/logos/gala-logo_horizontal_${
      this.goldMember ? 'gold' : this.darkMode ? 'white' : 'blue'
    }.png`);
  }

  get accountControlsColor() {
    return this.goldMember
      ? 'accentGold'
      : this.darkMode
      ? 'white'
      : 'accentBlue';
  }

  get topMargin() {
    return this.currentUser.loggedIn ? { marginTop: '60px' } : {};
  }

  get badgeFontSize() {
    if (this.newNotificationCount > 99) {
      return '0.8em';
    }
    return '1em';
  }

  get darkMode() {
    return this.$vuetify.theme.dark;
  }

  get themeChangeText() {
    return this.darkMode
      ? this.$t('components.home.topToolbar.lightsOn')
      : this.$t('components.home.topToolbar.lightsOff');
  }

  get discordConnected() {
    return !!this.currentUser.discordProfile;
  }

  trackPromoPackOpenEvent = () => {
    this.$ua.trackGalaPackShowOfferEvent({
      path: this.$route.path,
    });
  };

  handleThemeChange() {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
  }

  async handleLogout() {
    this.drawerControl = false;
    await this.userLogout();
  }

  goBack() {
    if (
      (this.currentPage.forceBackRoute || this.previousPage.sameAsCurrent) &&
      this.currentPage.backRoute
    ) {
      this.$router.push(this.currentPage.backRoute);
    } else {
      this.$router.back();
    }
  }

  handleShowNotifications() {
    this.$router.push('/notifications');
  }

  onTrackDiscordClick(link: string) {
    this.$ua.trackNavigationEvent({
      from: this.$route.fullPath,
      to: link,
    });
  }

  @Watch('currentUser.loggedIn', { immediate: true })
  async onUserUpdated(loggedIn: Boolean) {
    if (loggedIn) {
      this.getNewNotifications();
    }
  }
}
